module.exports = __webpack_public_path__ + "static/img/banner.9aa31fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star/yj/banner.png
// module id = 6rUo
// module chunks = 0